// extracted by mini-css-extract-plugin
export default {"buttonUpdatePrep":"AddressInfo_buttonUpdatePrep__ECGf8","button":"AddressInfo_button__xMMXN","stakeSpan":"AddressInfo_stakeSpan__mPAEW"};